import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";

const TITLE = "Portfolio-analyse — 27 projecten in 45 dagen | IT Solutions";
const DESC =
  "Analyse van 27 projecten (~453K regels code, 45 dagen). Van hospitality en e-commerce tot AI-revenue-management, HR en sport — bestuurde architectuur, drievoudig review-proces, enterprise-grade backend.";

import { AnalysePage } from "@/pages/analyse";

export const Route = createFileRoute("/analyse")({
  head: () =>
    pageHead({
      lang: "nl",
      pathWithoutLang: "/analyse",
      title: TITLE,
      description: DESC,
      ogType: "article",
    }),
  component: AnalysePage,
});
